import store from '@/store/index';
import MeUserGuard from '../routeGuards/MeUserGuard';
import { isDev } from '@/utils/helpers';

//* Function to lazy load pages
function lazyLoad(view) {
  return () => {
    return import(
      /* webpackPrefetch: true */ /* webpackChunkName: "[request]" */ `@/views/${view}`
    );
  };
}

const isClubHouseOwner = store.getters['users/isClubHouseOwner'];

// @ User ROUTING ============================================
const userRoutes = {
  path: '/users/:id?',
  component: lazyLoad('User'),
  // component: () => {
  //   return import(
  //     /* webpackPrefetch: true */ /* webpackChunkName: "shopPages" */ '@/views/ProductDetails'
  //   );
  // },
  props: true,
  meta: {
    content: 'default',
    clubhouseToolbar: false,
    clubhouseOwner: isClubHouseOwner,
    requiresAuth: true,
    hidden: true,
    header: 'User',
  },
  //* Needed anymore?
  // beforeEnter(to, from, next) {
  //   if (!to?.params?.id || to?.params?.id === 'undefined') {
  //     console.log('dispatch me =======================');
  //     store
  //       .dispatch('users/me')
  //       .then((res) => {
  //         next(`/users/${res.id}`);
  //       })
  //       .catch((error) => {
  //         const { response, data } = error;
  //         if ((response || data) && (response?.status === 404 || data?.status === 404)) {
  //           next({ name: 'notFound' });
  //         }
  //         //* Turn off connection issue page
  //         // else {
  //         //   next({ name: 'connectionIssue' });
  //         // }
  //       });
  //   } else {
  //     console.log('calling users/show=======================');
  //     store.dispatch('users/show', to.params.id).catch((error) => {
  //       console.error('error:', error);
  //       const { response, data } = error;
  //       if ((response || data) && (response?.status === 404 || data?.status === 404)) {
  //         next({ name: 'notFound' });
  //       }
  //       //* Turn off connection issue page
  //       // else {
  //       //   next({ name: 'connectionIssue' });
  //       // }
  //     });
  //     next();
  //   }
  // },
  children: [
    // {
    //   path: '',
    //   name: 'userStatsDashboard',
    //   component: lazyLoad('UserStatsDashboard'),
    //   meta: {
    //     content: 'default',
    //     clubhouseToolbar: false,
    //     clubhouseOwner: isClubHouseOwner,
    //     requiresAuth: true,
    //     hidden: true,
    //     header: 'User Dashboard',
    //     title: 'E6 User Stats Dashboard',
    //   },
    // },
    {
      path: '',
      name: 'userProfile',
      props: true,
      component: lazyLoad('UserProfile'),
      meta: {
        content: 'default',
        clubhouseToolbar: false,
        clubhouseOwner: isClubHouseOwner,
        requiresAuth: true,
        hidden: true,
        header: 'User Profile',
        title: 'E6 User Profile',
        metaTags: [
          {
            name: 'description',
            content: 'E6 Portal user profile page.',
          },
          {
            property: 'og:title',
            content: 'E6 User Profile',
          },
          {
            property: 'og:description',
            content: 'E6 Portal user profile page.',
          },
        ],
      },
    },
    {
      path: 'handicap-stats',
      name: 'userHandicapStats',
      component: lazyLoad('UserHandicapStats'),
      meta: {
        content: 'default',
        clubhouseToolbar: false,
        clubhouseOwner: isClubHouseOwner,
        requiresAuth: true,
        hidden: true,
        header: 'User Stats',
        title: 'E6 User Handicap Stats',
      },
    },
    //* Disabled for now. Not sure if we'll use this
    // {
    //   path: 'stats-dashboard',
    //   name: 'userStatsDashboard',
    //   component: lazyLoad('UserStatsDashboard'),
    //   meta: {
    //     content: 'default',
    //     clubhouseToolbar: false,
    //     clubhouseOwner: isClubHouseOwner,
    //     requiresAuth: true,
    //     hidden: true,
    //     header: 'User Stats',
    //     title: 'E6 User Stats Dashboard',
    //   },
    // },
    {
      path: 'metrics',
      name: 'userMetrics',
      component: lazyLoad('UserPerformanceMetrics'),
      props: true,
      // beforeEnter: MeUserGuard, //* disable for testing
      meta: {
        content: 'default',
        clubhouseToolbar: false,
        requiresAuth: true,
        hidden: true,
        header: 'User Performance Metrics',
        title: 'E6 User Performance Metrics',
      },
    },
    {
      path: 'skills-challenges',
      name: 'userSkillsChallenges',
      component: lazyLoad('UserSkillsChallenges'),
      props: true,
      meta: {
        content: 'default',
        clubhouseToolbar: false,
        requiresAuth: true,
        hidden: true,
        header: 'User Skills Challenges',
        title: 'E6 User Skills Challenges',
      },
    },
    {
      path: 'events',
      name: 'userEvents',
      component: lazyLoad('EventsUpdate'),
      props: true,
      meta: {
        clubhouseToolbar: false,
        clubhouseOwner: isClubHouseOwner,
        requiresAuth: true,
        hidden: true,
        header: 'User Events',
        title: 'E6 User Events',
      },
      beforeEnter(to, from, next) {
        if (to.params.userId === 'undefined') {
          next('/');
        }
        next();
      },
    },
    {
      path: 'seasons',
      name: 'userSeasons',
      component: lazyLoad('Seasons'),
      props: true,
      meta: {
        clubhouseToolbar: false,
        clubhouseOwner: isClubHouseOwner,
        requiresAuth: true,
        hidden: true,
        header: 'User Seasons',
        title: 'E6 User Seasons',
      },
    },
    //* moving out of user =============================
    // {
    //   path: 'bag-management',
    //   name: 'userGolfBagManagement',
    //   component: lazyLoad('UserGolfBagManagement'),
    //   props: true,
    //   beforeEnter: MeUserGuard,
    //   meta: {
    //     clubhouseToolbar: false,
    //     clubhouseOwner: isClubHouseOwner,
    //     requiresAuth: true,
    //     hidden: true,
    //     header: 'User Golf Bag Management',
    //     title: 'E6 User Golf Bag Management',
    //   },
    // },
    // {
    //   path: 'clubs',
    //   name: 'userGolfClubs',
    //   component: lazyLoad('UserGolfClubManagement'),
    //   props: true,
    //   beforeEnter: MeUserGuard,
    //   meta: {
    //     clubhouseToolbar: false,
    //     clubhouseOwner: isClubHouseOwner,
    //     requiresAuth: true,
    //     hidden: true,
    //     header: 'User Club Management',
    //     title: 'E6 User Club Management',
    //   },
    // },
    //* =======================================
    // {
    //   path: 'path',
    //   name: 'routeName',
    //   component: lazyLoad('pageName'),
    //   props: true,
    //   meta: {
    //     // requiresPermission: ['ADMIN'],
    //     requiresAuth: true,
    //     clubhouseToolbar: true,
    //     clubhouseOwner: isClubHouseOwner,
    //   },
    // },
  ],
};

export { userRoutes };
